import React from 'react';
import _ from 'lodash';
import ReactHighcharts from 'react-highcharts';
// import colorHelper from '../../lib/colorLuminance';

import './PieChart.scss';

class PieChart extends React.Component {
    render() {
        const { widget, widgetData, isThumbnail } = this.props;

        if (isThumbnail) {
            return (<div className="column_piechart_widget" />)
        }
        // const companyProfile = this.props.companyProfile;
        // const mainColor = colorHelper.colorLuminance(companyProfile.colors.mainBg, 0);
        // const lighterMainColor = colorHelper.colorLuminance(companyProfile.colors.mainBg, 0);

        // const colors = ['#052A4F', '#4A90E2', '#DB2023', '#F5A623', '#F8E71C', '#7ED321'];
        const colors = [];
        const base = '#4A90E2'; // ReactHighcharts.Highcharts.getOptions().colors[0];

        for (let x = 0; x < 10; x += 1) {
            if (widgetData.length > 2) {
                colors.push(
                    ReactHighcharts.Highcharts.Color(base).brighten(
                        (x - 2) / widgetData.length,
                    ).get(),
                );
            } else {
                colors.push(
                    ReactHighcharts.Highcharts.Color(base).brighten(
                        (x - 1) / widgetData.length,
                    ).get(),
                );
            }
        }

        const data = _.sortBy(widgetData, 'value').reverse();
        const chartData = _.map(data, (o, i) => {
            const value = typeof o.value === 'string' ? 0 : o.value;
            return { y: value, name: o.name, color: colors[i] };
        });

        const options = {
            chart: {
                type: 'pie',
                width: null,
                height: this.props.rowHeight ? this.props.rowHeight * widget.height : null,
                marginTop: 98,
                marginBottom: 40,
                spacingBottom: 0,
                spacingLeft: 0,
                spacingRight: 0,
                // marginLeft: -200,
                marginRight: 0,
            },
            tooltip: { enabled: false },
            credits: {
                enabled: false,
            },
            title: {
                text: '',
            },
            legend: {
                itemStyle: {
                    fontSize: '16px',
                    fontWeight: 'normal',
                },
                y: 100,
                itemMarginBottom: 5,
                itemMarginTop: 5,
                symbolPadding: 10,
                symbolHeight: 20,
                symbolWidth: 20,
            },
            plotOptions: {
                pie: {
                    allowPointSelect: false,
                    dataLabels: {
                        enabled: false,
                    },
                    borderColor: null,
                    showInLegend: true,
                    center: ['50%', '50%'],
                },
            },
            series: [
                {
                    name: '',
                    colorByPoint: true,
                    data: chartData,
                },
            ],
        };

        return (
            <div className="column_piechart_widget">
                <ReactHighcharts
                    config={options}
                    isPureConfig
                />
            </div>
        );
    }
}

PieChart.propTypes = {
    widget: React.PropTypes.object,
    widgetData: React.PropTypes.array,
    companyProfile: React.PropTypes.object,
    rowHeight: React.PropTypes.number,
};

export default PieChart;



/** WEBPACK FOOTER **
 ** ./client/components/Widgets/PieChart.jsx
 **/